<template>
  <breadCrumbs title="Date Picker" main="Form Widgets" title1="Date Picker" />
  <div class="container-fluid">
    <div class="card">
      <div class="card-header pb-0">
        <h3>Date Picker</h3>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <div class="date-picker">
              <form class="theme-form">
                <div class="mb-3 row g-3">
                  <label class="col-sm-3 col-form-label text-sm-end">Default</label>
                  <div class="col-xl-5 col-sm-9">
                    <div>
                      <datepicker class=" datepicker-here form-control digits" v-model="date" :format="format" />
                    </div>
                  </div>
                </div>
                <multipleDate />
                <monthDate />
                <minimumMaximum />
                <rangeDate />
                <disableDate />
                <orientationDate />
                <div class="mb-3 row g-3 mb-0">
                  <label class="col-sm-3 col-form-label text-sm-end">Permanently visible Datepicker</label>
                  <div class="col-sm-3">
                    <datepicker class="datepicker-here digits" inline autoApply v-model="date1" range data-language="en">
                    </datepicker>

                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import orientationDate from "./orientationDate.vue"
import multipleDate from "./multipleDate.vue"
import monthDate from "./monthDate.vue"
import minimumMaximum from "./minimumMaximum.vue"
import rangeDate from "./rangeDate.vue"
import disableDate from "./disableDate.vue"
import { ref } from 'vue';
export default {
  components: {
     orientationDate, multipleDate, monthDate, minimumMaximum, rangeDate, disableDate
  },
  data() {
    return {
      date1: [this.startDate, this.endDate],
    }
  },
  setup() {
    const date3 = ref();
    const date = ref();
        
        const format = (date) => {
            const day = date.getDate();
            const month = date.getMonth() + 1;
            const year = date.getFullYear();

            return ` ${day}/${month}/${year}`;
        }
    return {
      date3,
      date,
      format,
    }
  }
}
</script>
